var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerankerungGraphic = function SvgVerankerungGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 552.224 400.229"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "verankerung-graphic_svg__a",
    x1: 0.024,
    x2: 2.747,
    y1: 0.658,
    y2: -0.044,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfd0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#verankerung-graphic_svg__a",
    id: "verankerung-graphic_svg__b",
    x1: 0.598,
    x2: -0.133,
    y1: 0.623,
    y2: -0.011
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#verankerung-graphic_svg__a",
    id: "verankerung-graphic_svg__c",
    x1: 0.499,
    x2: 0.502,
    y1: 1.296,
    y2: 0.017
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#verankerung-graphic_svg__a",
    id: "verankerung-graphic_svg__d",
    x1: -0.072,
    x2: 0.592,
    y1: 1.034,
    y2: 0.458
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#verankerung-graphic_svg__a",
    id: "verankerung-graphic_svg__e",
    x1: -0.165,
    x2: 1.21,
    y1: 0.518,
    y2: 0.479
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verankerung-graphic_svg__a)",
    d: "M-1587.284 578.448v56.875h-36.293v-56.875s6.313-4.643 18.147-4.643 18.146 4.643 18.146 4.643",
    "data-name": "Pfad 110968",
    transform: "rotate(-35.02 -1520.111 -2231.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verankerung-graphic_svg__b)",
    d: "M-1463.974 578.448s6.313-4.643 18.147-4.643 18.146 4.643 18.146 4.643v56.875h-36.293Z",
    "data-name": "Pfad 110969",
    transform: "rotate(-35.02 -1495.326 -2153.364)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verankerung-graphic_svg__c)",
    d: "m-1515.455 569.242-.572-.236c-.483-.2-12.067-4.889-33.5-4.889s-33.016 4.689-33.5 4.889l-.572.237c-1.34-.9-8.22-5.126-19.852-5.126a38.67 38.67 0 0 0-18.147 4.115l11.792-10.368h120.554l11.792 10.368a38.7 38.7 0 0 0-18.147-4.115c-11.627 0-18.508 4.222-19.848 5.125",
    "data-name": "Pfad 110970",
    transform: "rotate(-35.02 -1511.95 -2233.477)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verankerung-graphic_svg__d)",
    d: "M-1499.532 635.323h-63.708v-56.875s11.082-4.643 31.854-4.643 31.854 4.643 31.854 4.643Z",
    "data-name": "Pfad 110971",
    transform: "rotate(-35.02 -1510.74 -2202.26)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verankerung-graphic_svg__e)",
    d: "M-1579.626 726.949a3.89 3.89 0 0 1 2.853-2.887l8.188-1.688v-52.811h64.015v27.746l10.131 11.634a4.67 4.67 0 0 1 .9 4.238 3.88 3.88 0 0 1-2.846 2.887l-7.533 1.551 9.476 10.889a4.65 4.65 0 0 1 .9 4.231 3.88 3.88 0 0 1-2.846 2.888l-7.533 1.551 9.476 10.889a4.65 4.65 0 0 1 .9 4.231 3.88 3.88 0 0 1-2.846 2.887l-7.533 1.551 9.476 10.889a4.65 4.65 0 0 1 .9 4.231 3.88 3.88 0 0 1-2.846 2.888l-7.533 1.551 9.476 10.888a4.66 4.66 0 0 1 .9 4.232 3.88 3.88 0 0 1-2.846 2.887l-7.533 1.551 9.476 10.889a4.66 4.66 0 0 1 .9 4.232 3.87 3.87 0 0 1-2.846 2.888l-7.533 1.55 9.476 10.888a4.66 4.66 0 0 1 .9 4.231 3.87 3.87 0 0 1-2.846 2.888l-7.533 1.551 9.476 10.889a4.66 4.66 0 0 1 .9 4.231 3.87 3.87 0 0 1-2.846 2.888l-7.533 1.551 9.476 10.888a4.66 4.66 0 0 1 .9 4.232 3.87 3.87 0 0 1-2.846 2.887l-7.533 1.551 9.476 10.889a4.66 4.66 0 0 1 .9 4.231 3.87 3.87 0 0 1-2.846 2.888l-8.187 1.688v54.258l-7.8 12.963h-48.413l-7.8-12.963v-29.196l-10.138-11.632a4.68 4.68 0 0 1-.9-4.239 3.91 3.91 0 0 1 2.853-2.888l7.539-1.551-9.49-10.882a4.68 4.68 0 0 1-.9-4.238 3.9 3.9 0 0 1 2.853-2.887l7.539-1.551-9.49-10.889a4.66 4.66 0 0 1-.9-4.231 3.91 3.91 0 0 1 2.853-2.888l7.539-1.551-9.49-10.889a4.66 4.66 0 0 1-.9-4.231 3.9 3.9 0 0 1 2.853-2.887l7.539-1.551-9.49-10.889a4.66 4.66 0 0 1-.9-4.231 3.91 3.91 0 0 1 2.853-2.888l7.539-1.551-9.49-10.889a4.66 4.66 0 0 1-.9-4.231 3.9 3.9 0 0 1 2.853-2.887l7.539-1.551-9.49-10.889a4.66 4.66 0 0 1-.9-4.231 3.9 3.9 0 0 1 2.853-2.888l7.539-1.551-9.49-10.889a4.66 4.66 0 0 1-.9-4.231 3.89 3.89 0 0 1 2.853-2.887l7.539-1.55-9.49-10.889a4.67 4.67 0 0 1-.9-4.231 3.9 3.9 0 0 1 2.853-2.888l7.539-1.551-9.49-10.888a4.68 4.68 0 0 1-.894-4.231m11.041 171.456 64.015-13.177v-11.006l-64.015 13.177Zm0-19.558 64.015-13.184v-11.005l-64.015 13.183Zm0-19.558 64.015-13.184V835.1l-64.015 13.184Zm0-19.558 64.015-13.184v-11.006l-64.015 13.183Zm0-19.558 64.015-13.183v-11.008l-64.015 13.184Zm0-19.558 64.015-13.184v-11.007l-64.015 13.184Zm0-19.559 64.015-13.183v-11.007l-64.015 13.184Zm0-19.558 64.015-13.184v-11.007l-64.015 13.184Zm0-19.559 64.015-13.183v-11.007l-64.015 13.184Z",
    "data-name": "Pfad 110972",
    transform: "rotate(-35.02 -1560.479 -2195.543)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 40649"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009cac",
    d: "M358.645 220.331a73.93 73.93 0 0 1-34.041-98.73 73.93 73.93 0 0 1 98.73-34.044 73.93 73.93 0 0 1 34.044 98.732 73.93 73.93 0 0 1-98.733 34.042m61.941-127.134a67.65 67.65 0 0 0-90.344 31.15 67.65 67.65 0 0 0 31.15 90.345 67.65 67.65 0 0 0 90.347-31.15 67.65 67.65 0 0 0-31.153-90.345",
    "data-name": "Pfad 110973"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009cac",
    d: "m504.696 206.248-8.33-118.4a7.14 7.14 0 0 0-3.993-5.913L385.672 29.95a7.14 7.14 0 0 0-7.116.5l-98.372 66.414a7.14 7.14 0 0 0-3.125 6.414l8.33 118.399a7.14 7.14 0 0 0 3.991 5.912l106.702 51.986a7.13 7.13 0 0 0 7.117-.5l98.372-66.413a7.13 7.13 0 0 0 3.125-6.414M355.35 227.681a81.113 81.113 0 0 1-37.391-108.445 81.113 81.113 0 0 1 108.444-37.392 81.113 81.113 0 0 1 37.392 108.444A81.113 81.113 0 0 1 355.35 227.68",
    "data-name": "Pfad 110974"
  })));
};
export default SvgVerankerungGraphic;